export default __webpack_public_path__ + "static/media/eńau - Negara Lucu ACOUSTIC SESSION (at Conclave Wijaya).01b7ab3b.mp3";